module.exports = __webpack_public_path__ + "static/19-7a38a5c5be524bfdec1bd014c66c1133.png";